const tz = {
  lang: 'tz', dir: 'ltr', flag: '🏔️', label: 'ⵜⴰⵎⴰⵣⵉⵖⵜ',

  nav: {
    home: 'Imagraden', map: 'Tafelwit', tools: 'Ifasen',
    messages: 'Iznan', profile: 'Uɣalen-iw', admin: 'Admin',
    login: 'Kccem', register: 'Rnu amiḍan', logout: 'Ffeɣ',
    publish: '+ Sken',
  },

  search: {
    title: 'Af axxam n umennuɣ-ik',
    subtitle: 'Safrec nnadi-k deg imagraden imɣanen',
    wilaya: 'Awilaya', commune: 'Timnaḍt', type: 'Anaw n uxxam',
    priceMin: 'Aẓar adday (DA)', priceMax: 'Aẓar ufella (DA)',
    btn: 'Nadi', reset: 'Sifrir',
    results: n => `${n} amagrad`,
    verified: 'Igmaḍ imɣanen',
    allWilayas: '— Meṛṛa wilayas —',
    chooseWilayaFirst: '— Fren awilaya uzrin —',
    allTypes: '— Meṛṛa ianawn —',
  },

  annonce: {
    types: {
      appartement: 'Appaṛṭima', villa: 'Avilla', studio: 'Astudyu',
      bureau: 'Tifras', local: 'Adukkan', terrain: 'Tuɣmaṭ',
      ferme: 'Taferma', maison: 'Axxam', duplex: 'Duplex',
    },
    surface: 'm²', rooms: 'tixxamiyin', bathrooms: 'ḥammam',
    seeDetails: 'Wali aglam',
    compare: 'Saṭṭaf', selected: 'Yettwafer',
    new: 'Amaynut', verified: 'Iɛeddel',
    addFav: 'Rnu ɣer ifaɣaren', removeFav: 'Kkes seg ifaɣaren',
    back: '← Uɣal',
    contact: 'Mmel yid-s',
    call: 'Isuter', whatsapp: 'WhatsApp', email: 'Tirawalt',
    message: 'Izen ɣef Darna Immo',
    share: 'Bḍu', similar: 'Imagraden yemxumbilen',
    guide: 'Agdil n umsaɣ',
    delete: 'Kkes amagrad',
    priceM2: 'DA/m²',
    negotiable: 'Izemmer',
    floor: 'Adaynin',
    interested: 'n imedduren',
  },

  tools: {
    title: 'Ifasen imaɣan',
    subtitle: 'Ifasen i tesɛiḍ deg umahil-ik',
    calcTitle: 'Amsefti n Ukariḍ',
    calcDesc: 'Ari iferdisen-ik s tɣermin n ibankan n Lezzayer.',
    estimTitle: 'Aɣalal n Azal',
    estimDesc: 'Aleɣ azal n uxxam-ik s wayen n lḥuma d taluft.',
    comparTitle: 'Tasaṭṭaft n Lhumat',
    comparDesc: 'Saṭṭaf isemliyen d tcenza gar lhumat.',
    calculate: 'Ari →', estimate: 'Aleɣ →', compare: 'Saṭṭaf →',

    price: 'Aẓar n uxxam (DA)', downPayment: 'Tiremt tamezwarut (DA)',
    duration: 'Tallit (iseggasen)', rate: 'Aẓar n uɣdim',
    calcBtn: 'Ari', resetBtn: 'Sifrir',
    monthly: 'Uferdis n wagur', totalCost: 'Timdi tamezwarut', totalInterest: 'Imzragen',
    amortTable: 'Tafyirt n umsallay',
    month: 'Aggur', principal: 'Amidel', interest: 'Iɣdimen',
    balance: 'Amidel illan',

    wilaya: 'Awilaya', commune: 'Timnaḍt', surfaceM2: 'Taluft (m²)',
    typeLogement: 'Anaw n uxxam', etage: 'Adaynin',
    estimBtn: 'Aleɣ azal', estimLoading: 'Iteḍra uɣalal…',
    estimResult: 'Azal n uɣalal', estimLow: 'Azal adday',
    estimHigh: 'Azal ufella', estimPriceM2: 'Azal agejdan/m²',
    backToTools: '← Ifasen',
    quartierLabel: 'Lḥuma', selectQuartier: 'Fren lḥuma',
    allTypesOption: 'Meṛṛa ianawn', roomsLabel: 'Tixxamiyin',
    estimError: 'Tella-d tuccḍa deg uɣalal',
    estimFor: 'Aɣalal i',
    confHigh: 'Taɣellist tamqrant', confMid: 'Taɣellist tamezwarut',
    confLow: 'Taɣellist meẓẓiyen', confNone: 'Isefkad ulac',
    estimatedValue: 'Azal n uɣalal',
    avgPrice: 'Azal agejdan', avgPriceM2: 'Azal agejdan/m²',
    avgSurface: 'Taluft tameddit', comparables: 'Imagraden yemxumbilen',
    minPrice: 'Azal adday', maxPrice: 'Azal ufella',
    toolsDisclaimer: 'Aɣalal yettunefk s imagraden n Darna Immo. Mačči d aɣalal arasmi.',
    addDistrict: '+ Rnu', availableTypes: 'Ianawn illan',
    nbAnnonces: 'Amḍan n imagraden',
    compareBtn: 'Saṭṭaf', comparLoading: 'Iteddu usaṭṭaf…',
    comparError: 'Tella-d tuccḍa deg usaṭṭaf',
  },

  auth: {
    loginTitle: 'Kccem', registerTitle: 'Rnu amiḍan',
    email: 'Imayl', phone: 'Usinaɣ', password: 'Awal n uεnan',
    name: 'Isem n ummid', firstName: 'Isem', lastName: 'Aqrab',
    loginBtn: 'Kccem', registerBtn: 'Rnu',
    noAccount: 'Ulac amiḍan-ik?', haveAccount: 'Yella umiḍan-ik?',
    forgotPassword: 'Tteṭṭfeḍ awal n uεnan?',
    orLogin: 'neɣ',
    loginSubtitle: 'Kccem ɣer umiḍan-ik n Darna Immo',
    registerSubtitle: 'Qqim d Darna Immo ufi axxam n umennuɣ-ik',
    locked: 'Amiḍan iqqen s wanida',
    lockedMsg: 'Tuḍen tikkwal. Ɛreḍ ticki',
    loginLoading: 'Iteddu ukeccem…', registerLoading: 'Iteddu urnu…',
    lockedBtn: '🔒 Iqqen',
    confirmPwd: 'Senqed',
    pwdNoMatch: 'Awalen n uεnan ur mṣadan ara',
    pwdTooShort: 'Awal n uεnan yessefk ad yili 8 n yisemnaden',
    connSuccess: 'Ukeccem yedda!', regSuccess: 'Urnu yedda!',
    createAccount: 'Rnu amiḍan', connect: 'Kccem',
  },

  profile: {
    title: 'Uɣalen-iw', myAnnonces: 'Imagraden-iw',
    stats: 'Isefkad', views: 'Iwalan', contacts: 'Immel',
    favorites: 'Ifaɣaren', published: 'Imagraden yesknen',
    editProfile: 'Beddel uɣalen', save: 'Uḥric',
    noAnnonces: 'Ulac imagraden-ik tura.',
    loading: 'Iteddu…',
    personalInfo: 'Isefka udmawanen',
    phoneNotSet: 'Ulac', phoneVerified: '(iɛeddel)',
    annoncesPub: 'Imagraden yesknen', memberSince: 'Ameddaken seg',
    verifyPhone: 'Senqed usinaɣ',
    statsSection: 'Isefkad n imagraden-ik',
    totalViews: 'Iwalan meṛṛa', contactsReceived: 'Immel imunen',
    inFavorites: 'Deg ifaɣaren', per30d: '/ 30ass',
    annonceCol: 'Amagrad', priceCol: 'Aẓar',
    statsEmpty: 'Ulac imagraden yesknen tura.',
    saveBtn: 'Uḥric',
  },

  messages: {
    title: 'Iznan', noConv: 'Ulac timmettanin',
    send: 'Azen', placeholder: 'Aru izen-ik… (Enter i usuffeɣ)',
    you: 'Kečč',
    exchanges: 'Timmettanin-ik d imsaɣan d ibaɛen',
    selectConv: 'Fren timmettant',
    yesterday: 'Iḍ-ass',
    disclaimer: 'Ur t-id-tazneḍ ara isefka n uṣṭur-ik. Fren tikkin deg yiɣerbazen iεemmen.',
  },

  common: {
    loading: 'Iteddu...', error: 'Tella-d tuccḍa',
    save: 'Uḥric', cancel: 'Seḥbes', delete: 'Kkes',
    edit: 'Beddel', yes: 'Ih', no: 'Ala', confirm: 'Senqed',
    close: 'Mdel', seeAll: 'Wali meṛṛa', noResult: 'Ulac yiwen',
    DA: 'DA', m2: 'm²',
  },

  carte: {
    title: 'Taeɣri n Lzzayer',
    subtitle: n => `Senqed ${n} n tewsatin sɛuddu timginin`,
    accessible: 'Iseɣ',
    moyen: 'Ammas',
    premium: 'Aqbayli',
    poisLabel: 'Timginin',
    scoresTitle: 'Inzan n tewsit',
    marketTitle: 'Asuddem n tɣellist',
    amenities: 'Timginin',
    propertyTypes: 'Ingan n tɣellist',
    listings: 'Imagraden',
    seeListings: q => `Wali imagraden n ${q}`,
    estimateBtn: 'Ɣez tɣellist',
    poi: {
      ecole: 'Timerna', mosquee: 'Imejjudayen', transport: 'Tanekra',
      commerce: 'Tamarkit', sante: 'Taɣellist', parc: 'Igezdisen',
    },
    score: {
      transport: 'Tanekra', securite: 'Taɣellist',
      education: 'Timerna', commerces: 'Tamarkit',
    },
  },

  create: {
    title: 'Sken amagrad',
    submit: 'Sken amagrad', cancel: 'Seḥbes',
    titleField: 'Azwel', description: 'Aglam',
    type: 'Anaw n uxxam', prix: 'Aẓar (DA)', surface: 'Taluft (m²)',
    rooms: 'Tixxamiyin', floor: 'Adaynin', photos: 'Tiwlafin',
    video: 'Tividyut', docs: 'Isemliyen ixeṣṣan',
    back: 'Uɣal',
    subtitle: 'Ari isefka ɣer wadda i usken n uxxam-ik.',
    progress: 'Aḥric',
    basicInfo: 'Isefka igejdanen',
    titleLabel: 'Azwel n umagrad',
    titlePlaceholder: 'Amedya: Avilla yelhan s ujeqqiq deg Hydra',
    descPlaceholder: 'Ḥkam axxam-ik: aḥal, adaynin, tafat…',
    typeLabel: 'Anaw n uxxam',
    location: 'Amḍiq',
    selectWilaya: 'Fren awilaya',
    selectCommune: 'Fren timnaḍt',
    chooseWilayaFirst: '— Fren awilaya uzrin —',
    priceAndSize: 'Aẓar d taluft',
    priceLabel: 'Aẓar (DA)',
    pricePlaceholder: 'Amedya: 50 000 000',
    surfaceLabel: 'Taluft (m²)',
    roomsLabel: 'Tixxamiyin',
    bathLabel: 'Iḥammamen',
    mediaSection: 'Tiwlafin & Tividyut',
    mediaNote: 'Rnu aṭas n 10 tiwlafin d yiwen uvidyu. Imagraden i tiwlafin ɣuren 5× n immel.',
    addPhotos: 'Sit i urnu n tiwlafin',
    photoHint: 'JPG, PNG, WEBP · aṭas n 10 · 5 MB tin',
    mainPhoto: 'Tawzart',
    videoLabel: 'Avidyu n uskan',
    optionalLabel: '(ur ixeṣṣ ara)',
    addVideo: 'Sit i urnu n uvidyu',
    videoHint: 'MP4, MOV · aṭas n 100 MB · 3 n tesragin',
    contactSection: 'Isefka n ummel',
    contactNote: 'Isefka-ik ad ttwawalint s imsaɣan.',
    phoneLabel: 'Usinaɣ',
    emailLabel: 'Imayl',
    docsSection: 'Isemliyen & Asenqed',
    docsNote: 'Send usken, senqed belli tesmalaḍ isemliyen ixeṣṣan.',
    docsLegal: 'Amagrad n tuccḍa ad d-yaweḍ i lḥebs n umiḍan s wanida.',
    submitting: 'Iteddu usken…',
    trustNote: 'Amagrad-ik ad yettwaɛeddel s tama n ufriq-nneɣ send usken.',
    errorCreating: 'Tella-d tuccḍa deg uxleq n umagrad',
    docsChecklist: [
      'Sɛiɣ asnekki n tɣellist neɣ taluft n tḥeywaḍt',
      'Taseddast n ubaɛ tella',
      'Aɣbalu n uɣerbaz iɛeddel yella',
      'Aẓar yemmal d aẓar n lbayɛ n tidet',
      'Isefka yesknant d imeqqranen akk',
    ],
  },
};
export default tz;
